module.exports = __webpack_public_path__ + "static/media/logo-sindoferry.be5cf501.svg";